import { PackagingFlowItem } from '../queries/api/types';

export const mapPackageFlowItems = (packages: PackagingFlowItem[]): Record<string, PackagingFlowItem> => {
    const flowMap: Record<string, PackagingFlowItem> = {};
    packages.forEach((pkg) => {
        flowMap[String(pkg.package)] = {
            package: pkg.package,
            shippedQuantity: pkg.shippedQuantity,
            goodCount: pkg.goodCount,
            badCount: pkg.badCount,
        };
    });
    return flowMap;
};

export const printPDF = async (
    response: Blob,
    onAfterPrint?: () => void,
    onError?: (error: unknown) => void,
    onPrintDialogOpen?: () => void
) => {
    const cleanUp = (iframe: HTMLIFrameElement, url: string) => {
        if (document.body.contains(iframe)) {
            document.body.removeChild(iframe);
        }
        URL.revokeObjectURL(url);
    };

    try {
        const url = URL.createObjectURL(response);
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

        if (isMobile) {
            // Open the PDF in a new tab for mobile users
            window.open(url, '_blank');
            if (onAfterPrint) {
                // Call the after-print callback immediately for mobile users
                setTimeout(() => {
                    onAfterPrint();
                }, 500);
            }
        } else {
            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            iframe.src = url;
            document.body.appendChild(iframe);

            const handleAfterPrint = () => {
                cleanUp(iframe, url);
                if (onAfterPrint) onAfterPrint();
            };

            iframe.onload = () => {
                try {
                    const iframeWindow = iframe.contentWindow;
                    if (!iframeWindow) throw new Error('Iframe contentWindow is not accessible');
                    iframeWindow.focus();
                    if (onPrintDialogOpen) onPrintDialogOpen();
                    iframeWindow.print();
                    window.addEventListener('focus', handleAfterPrint, { once: true });
                } catch (error) {
                    if (onError) onError(error);
                    handleAfterPrint();
                }
            };
        }
    } catch (error) {
        if (onError) onError(error);
    }
};

// Add this utility function to check file types
const allowedExt = ['.jpg', '.jpeg', '.png', '.pdf', '.doc', '.docx', '.xls', '.xlsx', '.asc'];

export const isFileValid = (files: Array<{ file: File }>): Array<{ file: File }> => {
    return files.filter((uploadedFile) => {
        const fileName = uploadedFile.file.name;
        const ext = fileName.substring(fileName.lastIndexOf('.')).toLowerCase();
        return !allowedExt.includes(ext);
    });
};
